<div class="loader">
    <div class="dimmed" [hidden]="status != STATUS_LOADING || version == null">
        <div class="dimmed_title"></div>
        <div class="dimmed_box"></div>
    </div>
    <!-- <core-helpers-box-loading [hidden]="status != STATUS_LOADING || version == null"></core-helpers-box-loading> -->
</div>
<article class="project-details-origin-version" *ngIf="status == STATUS_DONE">
    <header>
        <h3>ORIGINAL ARTWORK</h3>
    </header>
    <core-versions-summary-box
        [version]="version"
        [exclude]="version.labels"
        [feedbacks]="getFeedbacks(version)"
        [menu]="menu"
        (menuClick)="onMenuClick($event)"
        (actionFileClick)="onFileClick($event)"
    ></core-versions-summary-box>

</article>
